<template>
	<div class="configurator-step__page-selector">
		<h3>Aantal pagina's</h3>
		<p>Selecteer het aantal pagina's exclusief omslag:</p>
		<div class="flex-space flex-align--center mt-s">
			<input
				class="amount-input__range"
				:step="selectedFormat.pageIncrement"
				:min="0"
				:max="selectedFormat.maxPageCount"
				ref="amountInputRange"
				type="range"
				v-model.number="pageCount"
				placeholder="Aantal"
				@input="validatePageCount">
			<input
				class="amount-field ml-s mr-xs"
				:class="{'amount-field--invalid' : !valid}"
				type="number"
				:step="selectedFormat.pageIncrement"
				:min="selectedFormat.minPageCount"
				:max="selectedFormat.maxPageCount"
				v-model.number="pageCount"
				@blur="validatePageCount">
			<p>Pagina's</p>
		</div>

		<p v-show="unvalidPageCount" class="description__text color-error">Ongeldig aantal pagina's. Het aantal is teruggezet naar {{ pageCount }} pagina's.</p>

		<description v-if="hasDescription" />
	</div>
</template>

<script>
import description from "@/components/element/description";

export default {
	name: "PageCount",
	components: { description },
	data () {
		return {
			valid: false,
			unvalidPageCount: false
		};
	},
	computed: {
		pageCount: {
			get () {
				return this.$store.getters.getPageCount;
			},
			set (a) {
				this.setPageCount(a);
			}
		},
		selectedFormat () {
			return this.$store.getters.getSelectedFormat;
		},
		hasSelectedFormat () {
			return this.$store.getters.checkData.hasSelectedFormat;
		},
		printSidesAvailability () {
			return this.$store.getters.getPrintSidesAvailability;
		},
		textMinMaxIncrement () {
			return `Dit product heeft een minimum van ${this.selectedFormat.minPageCount} en een maximum van ${this.selectedFormat.maxPageCount} pagina's met een meervoud van ${this.selectedFormat.pageIncrement}.`;
		},
		dictionary () {
			return this.$store.getters.getDictionary;
		},
		isBookProduct () {
			return this.$store.getters.isBookProduct;
		},
		hasDescription () {
			const showDescription = this.$store.getters.getSelectedFormat.productOptionGroups.some(x =>
				this.dictionary.optionCategory[x.optionCategory] === "print"
				&& this.dictionary.chunkType[x.chunkType] === "content"
				&& this.isBookProduct
				&& this.pageCount > 0
			);

			return showDescription;
		}
	},
	methods: {
		setPageCount (data) {
			this.$store.commit("SET_PAGE_COUNT", data);
		},
		validatePageCount () {
			const min = this.selectedFormat.minPageCount;
			const max = this.selectedFormat.maxPageCount;
			const percentage = (this.pageCount / max) * 100;
			const rangeSlider = this.$refs.amountInputRange;

			if (rangeSlider) {
				rangeSlider.style.background = `linear-gradient(to right, var(--cfg-primary-dark) ${percentage}%, #fff ${percentage}%)`;
			}

			this.unvalidPageCount = false;

			clearTimeout(this.debounceTimeout);

			this.debounceTimeout = setTimeout(() => {
				this.valid = this.$store.getters.validatePageCount;

				if (!this.valid && !this.printSidesAvailability.set && this.hasSelectedFormat) {
					if (this.pageCount < min) {
						this.setPageCount(min);
					} else if (this.pageCount > max) {
						this.setPageCount(max);
					} else if (
						this.pageCount % this.selectedFormat.pageIncrement !== 0
						&& this.selectedFormat.pageIncrement !== 0
					) {
						const increment = this.selectedFormat.pageIncrement;
						const probableValid = Math.ceil(this.pageCount / increment) * increment;
						this.lastValidatedPageCount = this.pageCount;
						this.unvalidPageCount = true;
						this.setPageCount(probableValid);
					}

					this.validatePageCount();
				}
			}, 500);
		},
		pageCountIncrement () {
			this.pageCount = this.pageCount + this.selectedFormat.pageIncrement;
			this.validatePageCount();
		},
		pageCountDecrement () {
			this.pageCount = this.pageCount - this.selectedFormat.pageIncrement;
			this.validatePageCount();
		}
	},
	created () {
		if (this.pageCount < this.selectedFormat.minPageCount
			|| this.pageCount > this.selectedFormat.maxPageCount
			|| this.pageCount === null) {
			this.pageCount = this.selectedFormat.minPageCount;
		}
		this.validatePageCount();
	},
	mounted () {
		this.validatePageCount();
	},
	watch: {
		selectedFormat: function (a, b) {
			this.validatePageCount();
		}
	}
};
</script>

<style lang="scss">
input[type="range"]:disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/optional/page-count.vue